import { Link, useLocation } from "react-router-dom";
import { useSite } from "@/context/SiteContext";

export default function Footer() {
  const { settings } = useSite();
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return null;

  const s = settings || {};
  const year = new Date().getFullYear();

  return (
    <footer className="bg-ink text-ivory relative" data-testid="site-footer">
      <div className="mx-auto px-6 md:px-12 lg:px-16 pt-24 md:pt-32 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <p className="label-mono opacity-60 mb-6">01 — Cape Town</p>
            <h3 className="font-editorial text-3xl md:text-4xl leading-[1.1] max-w-md">
              {s.about_message || "Tell us what you are celebrating."}
            </h3>
            <div className="mt-8 flex gap-4 flex-wrap">
              <Link to="/booking" className="btn-outline-ivory" data-testid="footer-cta-booking">
                Check Availability
              </Link>
              <Link to="/contact" className="btn-outline-ivory" data-testid="footer-cta-contact">
                Contact Oereshaus
              </Link>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="label-mono opacity-60 mb-5">Navigate</p>
            <ul className="space-y-3">
              {[
                ["Home", "/"],
                ["Portfolio", "/portfolio"],
                ["Services", "/services"],
                ["About", "/about"],
                ["Contact", "/contact"],
                ["Booking", "/booking"],
              ].map(([label, to]) => (
                <li key={to}>
                  <Link to={to} className="hover-underline text-ivory/80 hover:text-ivory" data-testid={`footer-link-${label.toLowerCase()}`}>
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="label-mono opacity-60 mb-5">Connect</p>
            <ul className="space-y-3">
              {s.client_galleries_url && (
                <li>
                  <a href={s.client_galleries_url} target="_blank" rel="noreferrer" className="hover-underline text-ivory/80" data-testid="footer-client-galleries">
                    Client Galleries
                  </a>
                </li>
              )}
              {s.instagram_url && (
                <li>
                  <a href={s.instagram_url} target="_blank" rel="noreferrer" className="hover-underline text-ivory/80" data-testid="footer-instagram">
                    Instagram
                  </a>
                </li>
              )}
              {s.tiktok_url && (
                <li>
                  <a href={s.tiktok_url} target="_blank" rel="noreferrer" className="hover-underline text-ivory/80" data-testid="footer-tiktok">
                    TikTok
                  </a>
                </li>
              )}
              {s.business_email && (
                <li>
                  <a href={`mailto:${s.business_email}`} className="hover-underline text-ivory/80" data-testid="footer-email">
                    Email
                  </a>
                </li>
              )}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="label-mono opacity-60 mb-5">Legal</p>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy" className="hover-underline text-ivory/80" data-testid="footer-privacy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms" className="hover-underline text-ivory/80" data-testid="footer-terms">Terms & Conditions</Link>
              </li>
              <li>
                <Link to="/admin" className="hover-underline text-ivory/50" data-testid="footer-admin">Admin</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-24 md:mt-32 border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="label-mono opacity-60">
            © {year} Oereshaus Photography &amp; Films
          </p>
          <p className="label-mono opacity-60">
            {s.location || "Cape Town, South Africa"}
          </p>
        </div>

        <div className="mt-14 select-none">
          <img
            src="/brand/oereshaus-white.webp"
            alt="Oereshaus"
            className="w-full block"
            data-testid="footer-wordmark"
            draggable="false"
          />
        </div>
      </div>
    </footer>
  );
}
